import { } from 'react';
import Icon from '../../../../components/Icon/Icon';

const WhatsAppMainNavigationTabs = ({ activeTab, onTabChange, userRole }) => {
  const getTabStyle = (isActive, isDisabled = false) => ({
    backgroundColor: isActive ? '#FFFFFF' : '#ECEFF1',
    color: isActive ? '#143A62' : '#9CA8BB',
    border: 'none',
    borderRadius: '15px 15px 0px 0px',
    padding: '8px 20px',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '1.5em',
    letterSpacing: '0.25%',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    width: '159px',
    height: '46px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    textAlign: 'left'
  });

  const baseTabs = [
    {
      key: 'inbox',
      label: 'Inbox',
      icon: 'inbox',
      iconWidth: 19,
      iconHeight: 16,
      disabled: false
    },
    {
      key: 'contacts',
      label: 'Contacts',
      icon: 'contacts',
      iconWidth: 20,
      iconHeight: 22,
      disabled: false
    }
  ];

  const managerTabs = [
    {
      key: 'agents',
      label: 'Agents',
      icon: 'agents',
      iconWidth: 24,
      iconHeight: 12,
      disabled: false
    },
    {
      key: 'billings',
      label: 'Billings',
      icon: 'billings',
      iconWidth: 19,
      iconHeight: 16,
      disabled: false
    },
    {
      key: 'settings',
      label: 'Settings',
      icon: 'settings',
      iconWidth: 19,
      iconHeight: 19,
      disabled: false
    }
  ];

  const tabs = userRole === 'manager'
    ? [...baseTabs, ...managerTabs]
    : baseTabs;

  return (
    <div className="main-tabs-container" style={{
      padding: '20px 40px 0 40px',
      borderBottom: 'none'
    }}>
      <div className="main-navigation-tabs" style={{
        backgroundColor: 'transparent',
        gap: '15px',
        display: 'flex',
        flexDirection: 'row'
      }}>
        {tabs.map((tab) => (
          <div key={tab.key} className="nav-item" style={{
            marginBottom: 0,
            width: '159px',
          }}>
            <div
              className="nav-link"
              onClick={() => !tab.disabled && onTabChange && onTabChange(tab.key)}
              style={getTabStyle(activeTab === tab.key && !tab.disabled, tab.disabled)}
            >
              <Icon
                name={tab.icon}
                color={activeTab === tab.key ? '#0BA9E0' : '#9CA8BB'}
                width={tab.iconWidth}
                height={tab.iconHeight}
              />
              {tab.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhatsAppMainNavigationTabs;
